var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeslasupercharger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "100 200 544.09 652.36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m184.86 610.93c5.3425-9.4116 20.615 5.5027 32.325 3.0305s21.396-12.731 34.345-19.193c36.307-19.01 81.459-28.176 119.2-28.284 50.786 1.9146 74.271 7.4174 116.17 29.294 11.091 5.7846 22.315 18.455 31.315 20.203s30.546-16.675 37.376-6.0609c8.5404 13.272-26.264 39.396-26.264 39.396l-52.528 30.305-67.68 19.193-79.802 1.0102-58.589-15.152-55.558-32.325s-38.749-26.54-30.305-41.416z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "current"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.35,
    cy: 418.67,
    rx: 83.018,
    ry: 86.048,
    fill: "none",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 499.05,
    cy: 418.67,
    rx: 83.018,
    ry: 86.048,
    fill: "none",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.31 316.91s-33.086 4.3562-48.992 9.1523c-20.646 6.2253-42.55 11.998-59.558 25.254-11.004 8.5761-18.999 20.905-25.254 33.376-5.9662 11.895-8.5532 25.286-11.112 38.345-2.4736 12.626-3.8972 25.521-4.0406 38.386-0.13556 12.163 1.2225 24.334 3.0102 36.365 1.8731 12.607 4.3376 25.187 8.0609 37.376 4.2378 13.873 9.8912 27.325 16.162 40.406 6.5181 13.596 13.505 27.095 22.223 39.396 8.2783 11.681 17.648 22.743 28.305 32.305 12.236 10.979 25.911 20.512 40.386 28.305 13.709 7.3808 28.393 13.16 43.437 17.173 15.782 4.2093 32.191 5.9642 48.487 7.0711 18.31 1.2437 36.786 1.2502 55.053-0.50508 17.553-1.6866 35.174-4.3949 52.023-9.5964 15.128-4.6702 29.672-11.39 43.437-19.213 11.128-6.3246 21.877-13.577 31.315-22.223 13.031-11.937 24.406-25.774 34.345-40.386 9.6588-14.199 17.719-29.572 24.244-45.457 6.2739-15.275 10.912-31.283 14.142-47.477 2.8478-14.277 4.2578-28.881 4.5457-43.437 0.36027-18.217-0.0313-36.667-3.5355-54.548-2.862-14.604-5.9399-29.928-14.142-42.345-8.6927-13.159-21.876-23.276-35.396-31.396-13.231-7.9462-28.529-11.999-43.396-16.142-12.215-3.4045-24.888-4.8876-37.376-7.0914l-17.173-3.0305",
    fill: "none",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.32 315.87s24.122-5.0748 34.72-6.8747c10.598-1.7998 29.902-2.315 50.083-3.1173 10.761-0.42781 21.529-0.99049 32.303-1.0053 11.815-0.0162 23.623 0.55736 35.429 1.0053 7.3392 0.27845 14.702 0.29618 22.008 1.0457l29.105 2.9858",
    fill: "none",
    strokeWidth: 20.264
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.58 560.71s6.1336-29.44 3.8872-43.987c-0.97642-6.323-2.7351-13.493-7.3783-17.719-4.2459-3.8647-8.8882-7.8498-18.025-8.8483-9.1366-0.99857-26.303 8.0604-26.303 8.0604",
    fill: "none",
    strokeWidth: 28.588
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.56 560.96s-6.3762-30.106-3.6715-44.865c1.2335-6.731 3.5893-13.785 8.821-18.538 0 0 10.034-5.7795 15.434-6.284s18.662 2.8744 18.662 2.8744",
    fill: "none",
    strokeWidth: 28.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.44 349.75s12.082-15.943 7.5006-28.506c-4.5352-12.436-20.095-13.811-20.095-13.811",
    fill: "none",
    strokeWidth: 20.169
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.27,
    y: 468.49,
    width: 36.365,
    height: 18.183,
    ry: 9.0914,
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.63,
    y: 472.53,
    width: 36.365,
    height: 18.183,
    ry: 9.0914,
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 473.55,
    cy: 625.19,
    rx: 23.719,
    ry: 23.214,
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 14.232
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.21,
    cy: 627.09,
    rx: 37.339,
    ry: 36.834,
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 8.4502
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.62,
    cy: 625.07,
    rx: 23.719,
    ry: 23.214,
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 14.232
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.06 349.75s-12.082-15.943-7.5006-28.506c4.5352-12.436 20.095-13.811 20.095-13.811",
    fill: "none",
    strokeWidth: 20.169
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslasupercharger);
export default __webpack_public_path__ + "static/media/teslasupercharger.a155daf1a7defc5497598bba0e8cb0a9.svg";
export { ForwardRef as ReactComponent };